import { capitalizeFirstLetter } from '../transforms/capitalizeFirstLetter';
import { overrideBaseLocale } from './base-config';
export var ptPT = overrideBaseLocale('pt-PT', {
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter],
    },
    monthShort: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter],
    },
});
//# sourceMappingURL=pt-PT.js.map